import { useState } from "react";

export default function Earnings({ fields }) {
  const [state, setState] = useState({
    ...fields.data,
    selectedPrice: fields.data.prices[0],
    selectedQuantity: fields.data.quantities[0],
  });

  return (
    <section className='relative px-4 md:px-8 xl:px-0 pb-16 shadow-lg'>
      <div className="max-w-7xl mx-auto  grid grid-cols-1 lg:grid-cols-2 overflow-hidden rounded-lg border-2 border-brand-500  shadow-lg">
        <div className="col-span-1 p-12 bg-brand-500 text-white ind flex flex-col items-center justify-center">
          {fields.title && (
            <h3 className="mt-2 mb-4 text-2xl leading-8 font-extrabold tracking-tight sm:text-4xl">
              {fields.title}
            </h3>
          )}
          {fields.text && (
            <p>
              {fields.text}
            </p>
          )}          
        </div>
        <div className="bg-white col-span-1 px-4 lg:px-12 pb-12 md:p-12">
          <div className='divide-y-2 divide-brand-600 '>
            <div className="flex flex-col md:flex-row items-center py-8">
              <p className="flex-1 mb-4 md:mb-0">Price Per Treatment</p>
              <div className="flex justify-between w-full md:w-auto">
                {state.prices.map((q, i) => (
                  <div
                    key={i}
                    className={`cursor-pointer p-4 flex-1 border-t-2 border-b-2 border-l-2 border-brand-500 text-center last:border-r-2 ${
                      q === state.selectedPrice ? "bg-brand-500 text-white" : ""
                    }`}
                    onClick={() => setState({ ...state, selectedPrice: q })}
                  >
                    £{q}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex flex-col md:flex-row items-center py-8">
              <p className="flex-1 mb-4 md:mb-0">Treatments per week</p>
              <div className="flex justify-between w-full md:w-auto">
                {state.quantities.map((q, i) => (
                  <div
                    key={i}
                    className={`cursor-pointer p-4 flex-1 border-t-2 border-b-2 border-l-2 border-brand-500 text-center last:border-r-2 ${
                      q === state.selectedQuantity ? "bg-brand-500 text-white" : ""
                    }`}
                    onClick={() => setState({ ...state, selectedQuantity: q })}
                  >
                    {q}
                  </div>
                ))}
              </div>
            </div>
            <div className="flex items-center py-8">
              <p className="flex-1">Weekly revenue</p>
              <p className="text-2xl leading-8 font-extrabold tracking-tight sm:text-4xl">
              {new Intl.NumberFormat("en-GB", {
                  style: "currency",
                  currency: "GBP",
                }).format(state.selectedPrice * state.selectedQuantity)}
              </p>
            </div>
            <div className="flex items-center pt-8">
              <p className="flex-1">Annual revenue</p>
              <p className="text-2xl leading-8 font-extrabold tracking-tight sm:text-4xl">
                {new Intl.NumberFormat("en-GB", {
                  style: "currency",
                  currency: "GBP",
                }).format(state.selectedPrice * state.selectedQuantity * 46)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
